import { render, staticRenderFns } from "./article-history-list.vue?vue&type=template&id=8820bcc2&"
import script from "./article-history-list.vue?vue&type=script&lang=js&"
export * from "./article-history-list.vue?vue&type=script&lang=js&"
import style0 from "./article-history-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "article-history-list.vue"
export default component.exports